import React, { useState, useEffect } from "react";

const InputOnlyNumber = ({
  label,
  name,
  value = "",
  onChange,
  placeholder = "",
  required = false,
  readOnly = false,
  fieldName = "This field",
  setInputOnlyNumberError, 
}) => {
  const [errMsg, setErrMsg] = useState("");
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      onChange(e);
      setErrMsg(""); 
      if (setInputOnlyNumberError) {
        setInputOnlyNumberError((previousState) => ({
          ...previousState,
          onlyNumber: false,
        }));
      }
    } else {
      setErrMsg("Only Number and one decimal point are allowed.");
      if (setInputOnlyNumberError) {
        setInputOnlyNumberError((previousState) => ({
          ...previousState,
          onlyNumber: true, 
        }));
      }
    }
  };

  const handleBlurCheck = () => {
    const trimmedValue = String(value).trim();
    if (required && trimmedValue === "") {
      const requiredMessage = `${fieldName} is required.`;
      setErrMsg(requiredMessage);
      if (setInputOnlyNumberError) {
        setInputOnlyNumberError((previousState) => ({
          ...previousState,
          onlyNumber: true, 
        }));
      }
    } else {
      setErrMsg(""); 
      if (setInputOnlyNumberError) {
        setInputOnlyNumberError((previousState) => ({
          ...previousState,
          onlyNumber: false, 
        }));
      }
    }
  };

  useEffect(() => {
    if (!errMsg && setInputOnlyNumberError) {
      setInputOnlyNumberError((previousState) => ({
        ...previousState,
        onlyNumber: false, 
      }));
    }
  }, [errMsg, setInputOnlyNumberError]);

  return (
    <>
      <div className="form-group">
        <label htmlFor={name} className="col-form-label">
          {label}
        </label>
        <input
          type="text"
          className="form-control"
          name={name}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlurCheck}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
        />
      </div>
      <small className="text-danger">{errMsg}</small>
    </>
  );
};

export default InputOnlyNumber;
